<template>
  <div>
    <a-card>
      <a-form ref="form"
        class="form" style="display:block"
        layout="inline"
        :model="form">
        <div class="paragraph-title" style="display: flex; justify-content: space-between">
          <span>个人信息</span>
          <a-button v-if="!editting" @click="editting = true" type="primary">编辑信息</a-button>
        </div>
        <a-form-item label="姓名">
          <a-input v-if="editting" v-model:value="form.name" autocomplete="off"></a-input>
          <span v-else>{{ userInfo.name }}</span>
        </a-form-item>
        <a-form-item label="电话">
          <a-input v-if="editting" v-model:value="form.mobile" autocomplete="off"></a-input>
          <span v-else>{{ userInfo.mobile }}</span>
        </a-form-item>
        <a-form-item label="邮箱">
          <a-input v-if="editting" v-model:value="form.email" autocomplete="off"></a-input>
          <span v-else>{{ userInfo.email }}</span>
        </a-form-item>
        <br>
        <div class="paragraph-title" style="margin-top: 30px">
          <span>账号信息</span>
        </div>
        <a-form-item label="账号ID">
          <span>{{ userInfo.userId }}</span>
        </a-form-item>
        <!-- <a-form-item label="生成时间">
          <span>{{ getDateTime(userInfo.createTime) }}</span>
        </a-form-item> -->
        <a-form-item label="登录账号">
          <span>{{ userInfo.username }}</span>
        </a-form-item>
        <a-form-item label="密码" style="width: 100px">
          <span>******</span>
        </a-form-item>
        <a-form-item style="width: 100px">
          <a-button
            v-if="!editting"
            @click="openModifyPassword"
            type="primary">修改密码</a-button>
        </a-form-item>
        <br>
        <div class="paragraph-title" style="margin-top: 30px">
          组织信息
        </div>
        <a-table :dataSource="dataSource" :columns="columns" :pagination="false" rowKey="id">
          <template #companyId="{ text }">{{ getCompanyName(text) }}</template>
          <template #teamId="{ text }">{{ getTeamName(text) }}</template>
          <template #roleId="{ text }">{{ getRoleName(text) }}</template>
        </a-table>
      </a-form>
      <a-button style="margin-right: 20px" v-if="editting" type="primary" @click="handleSubmit">保存</a-button>
      <a-button v-if="editting" type="default" @click="handleCancel">取消</a-button>
    </a-card>
    <PasswordDialog ref="passwordDialog"></PasswordDialog>
  </div>
</template>
<script>
import PasswordDialog from './PasswordDialog'
import { mapState } from 'vuex'
import { updateUser } from '@/api/user'
import { getDateTime, getCompanyName, getTeamName, getRoleName } from '@/filters'
export default {
  components: {
    PasswordDialog
  },
  data () {
    return {
      form: {
        name: '',
        mobile: '',
        email: ''
      },
      columns: [
        {
          title: '公司',
          dataIndex: 'companyId',
          slots: { customRender: 'companyId' },
          key: 'companyId'
        },
        {
          title: '团队',
          dataIndex: 'teamId',
          slots: { customRender: 'teamId' },
          key: 'teamId'
        },
        {
          title: '角色',
          dataIndex: 'roleId',
          slots: { customRender: 'roleId' },
          key: 'roleId'
        }
      ],
      editting: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'optionalRoles']),
    dataSource () {
      if (this.optionalRoles && this.optionalRoles.length) {
        return this.optionalRoles.map((i, index) => ({ ...i, id: index + 1 }))
      } else {
        return []
      }
    }
  },
  watch: {
    userInfo: {
      handler (val) {
        if (val) {
          this.form = {
            name: val.name,
            mobile: val.mobile,
            email: val.email
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getDateTime,
    getCompanyName,
    getTeamName,
    getRoleName,
    handleSubmit () {
      updateUser({
        userId: this.userInfo.userId,
        username: this.userInfo.username,
        roleId: this.userInfo.roleId,
        status: this.userInfo.status,
        ...this.form
      }).then(res => {
        this.editting = false
        this.handleUpdate()
      }).catch(err => {
        this.$message.error(err.response.data.message)
      })
    },
    async handleUpdate () {
      // 某些情况下，这里需要一个try catch
      let oldUserInfo = {}
      try {
        oldUserInfo = JSON.parse(localStorage.getItem('westUserInfo'))
      } catch {
        oldUserInfo = {}
      }
      Object.keys(this.form).forEach(key => {
        oldUserInfo[key] = this.form[key]
      })
      console.log('修改后', oldUserInfo)
      localStorage.setItem('westUserInfo', JSON.stringify(oldUserInfo))
      this.$store.commit('setUserInfo', oldUserInfo)
    },
    handleCancel () {
      this.editting = false
      this.form = {
        name: this.userInfo.name,
        mobile: this.userInfo.mobile,
        email: this.userInfo.email
      }
    },
    openModifyPassword () {
      this.$refs.passwordDialog.open()
    }
  }
}
</script>
<style lang="less" scoped>
.form {
  margin-bottom: 30px;
  .ant-form-item {
    width: 300px;
  }
}
</style>
